export class IngestionPipelineAccess {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "deniedScopes",
            "baseName": "deniedScopes",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return IngestionPipelineAccess.attributeTypeMap;
    }
    constructor() {
    }
}
